import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[notdot]',
    standalone: false
})
export class EaNotDotDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Empêche la saisie des caractères décimaux
    if (event.key === '.' || event.key === ',' || event.key === 'e') {
      event.preventDefault();
    }
  }
}
